import React from 'react';
import { Card, Box, Typography, Divider } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import File from '../../assets/images/folder.jpg';

function Integration() {
    const handleShareClick = () => {
        window.open('https://documenter.getpostman.com/view/23897142/2s847FtsnY', '_blank');
    };

    return (
        <Card variant="outlined" sx={{ p: 0, borderRadius: 3, boxShadow: 3 }}>
            <Box sx={{ p: '20px 30px', textAlign: 'center', bgcolor: '#f7f9fc' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1a237e' }}>
                    Integration
                </Typography>
            </Box>

            <Box sx={{ px: 4, py: 2, textAlign: 'center' }}>
                <Typography variant="body2" sx={{ color: '#555', fontSize: 14, lineHeight: 1.6, mb: 1 }}>
                    By integrating with third-party services, you're responsible for reviewing and understanding their terms and conditions.
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, fontSize: 14, mb: 2 }}>
                    Want to see a specific integration? Drop us a line at{' '}
                    <a href="mailto:sales@ubankconnect.com" style={{ color: '#1976d2', textDecoration: 'underline' }}>
                        sales@ubankconnect.com
                    </a>.
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
                <Box
                    onClick={handleShareClick}
                    sx={{
                        width: 110,
                        height: 110,
                        backgroundImage: `url(${File})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 4,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: 6,
                        position: 'relative',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.08)',
                        },
                    }}
                >
                    <ShareIcon
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            fontSize: 24,
                            color: '#fff',
                            backgroundColor: '#1976d2',
                            borderRadius: '50%',
                            p: '5px',
                        }}
                    />
                </Box>

                <Divider sx={{ width: '60%', my: 4 }} />

                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 600,
                        fontSize: 15,
                        color: '#0d47a1',
                        textAlign: 'center',
                    }}
                >
                    🚀 Click the folder to instantly view our integration guide!
                </Typography>
            </Box>
        </Card>
    );
}

export default Integration;
